import type { ComponentType } from 'react';
import type { LazyRouteFunction, RouteObject } from 'react-router';

/**
 * Route-level code splitting. Each page loads in its own chunk on first navigation:
 * `{ path: 'tickets', lazy: page(() => import('./tickets-page'), (m) => m.TicketsPage) }`.
 */
export function page<M>(load: () => Promise<M>, pick: (m: M) => ComponentType): LazyRouteFunction<RouteObject> {
  return async () => ({ Component: pick(await load()) });
}
